import script from "./StickyBreadcrumb.vue?vue&type=script&setup=true&lang=ts"
export * from "./StickyBreadcrumb.vue?vue&type=script&setup=true&lang=ts"

import "./StickyBreadcrumb.vue?vue&type=style&index=0&id=6ade2dd6&lang=scss&scoped=true"
script.__scopeId = "data-v-6ade2dd6"

export default script